import { getRequest, postRequest } from ".";
import apiEndpoints from "./apiEndpoints";

export const getTests = () => getRequest(apiEndpoints.screeningTest.allTests);
export const createTest = (payload) =>
  postRequest(apiEndpoints.screeningTest.createTest,payload);
